import React from 'react';
import { useIntl } from 'react-intl';

interface Props {
    onClick: () => void;
    disabled?: boolean;
    /** Tooltip / aria-label. Falls back to "Export CSV". */
    title?: string;
}

/**
 * Small download-arrow icon button used in each widget header. Tooltip-only
 * (no visible text) to keep the card header light.
 */
const ExportButton: React.FC<Props> = ({ onClick, disabled, title }) => {
    const intl = useIntl();
    const label =
        title ||
        intl.formatMessage({ id: 'analyticsV2.export.button', defaultMessage: 'Export CSV' });
    return (
        <button
            type="button"
            className="av2-export-btn"
            onClick={onClick}
            disabled={disabled}
            title={label}
            aria-label={label}
        >
            <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
            >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
        </button>
    );
};

export default ExportButton;
